import { Button } from "@/components/ui/button";
import { Minus, Plus } from "lucide-react";
import React, { forwardRef, InputHTMLAttributes } from "react";

export type Ref = HTMLInputElement;

export const NumberInput = forwardRef<
  Ref,
  InputHTMLAttributes<HTMLInputElement> & {
    label: string;
    error?: string | string[];
    showButtons?: boolean;
  }
>((props, ref) => {
  const [value, setValue] = React.useState(
    props.defaultValue || props.value || "",
  );

  return (
    <div>
      <label
        className={`block text-sm font-medium leading-6 text-zinc-950 ${
          props.disabled && "text-gray-300"
        }`}
      >
        {props.label}
      </label>
      <div className="mt-1">
        <div className="flex gap-2">
          {props.showButtons && (
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={() => setValue((Number(value) - 1).toString())}
            >
              <Minus size={16} />
            </Button>
          )}
          <input
            {...props}
            ref={ref}
            type="number"
            value={value}
            defaultValue={props.defaultValue}
            onChange={(e) => {
              setValue(e.target.value);
              props.onChange?.(e);
            }}
            className={`block w-full rounded-md border-0 py-1.5 text-zinc-950 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-3 disabled:ring-zinc-100 disabled:bg-gray-100 disabled:border disabled:border-gray-200 ${props.style}`}
            disabled={props.disabled}
          />
          {props.showButtons && (
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={() => setValue((Number(value) + 1).toString())}
            >
              <Plus size={16} />
            </Button>
          )}
        </div>
        {props.error && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-500">
            {props.error}
          </p>
        )}
      </div>
    </div>
  );
});
NumberInput.displayName = "NumberInput";
